import { createBrowserRouter } from "react-router-dom";
import RouteNames from "./type";
import Layout from "./layout";
import PageNotFound from "../pages/PageNotFound";
import Auth from "../pages/Auth";
import Callback from "../pages/Callback";
import PoDealer from "../pages/home";
import AddContracts from "../pages/AddContract";
import AddContractFile from "../pages/AddContractsFile";
import SubmitTicket from "../pages/SubmitTicket";
import Unauthorized from "../pages/Unauthorized";
import AddUnRegisterContract from "../pages/AddUnRegisterContract";
import NotFoundPage from "../components/NotFoundPage";

export const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: RouteNames.ERROR,
        element: <PageNotFound />,
      },
      {
        path: RouteNames.SUBMIT_TICKET,
        element: <SubmitTicket />,
      },
      {
        path: RouteNames.CONTRACTS,
        element: <PoDealer />,
      },
      {
        path: RouteNames.ADD_CONTRACT,
        element: <AddContracts />,
      },
      {
        path: RouteNames.ADD_CONTRACT_FILE,
        element: <AddContractFile />,
      },
    ],
    errorElement: <NotFoundPage />,
  },
  {
    path: RouteNames.UNAUTHORIZED,
    element: <Unauthorized />,
  },
  {
    path: RouteNames.AUTH,
    element: <Auth />,
  },
  {
    path: RouteNames.CALLBACK,
    element: <Callback />,
  },
  {
    path: RouteNames.ERROR,
    element: <PageNotFound />,
  },
  {
    path: RouteNames.ADD_UNREGISTERED_CONTRACT,
    element: <AddUnRegisterContract />,
  },
]);
